import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import classNames from 'classnames';
import { CONTENT_CONTAINER } from 'globalConst/const';
import * as cssVariable from 'cssVariables';
import getMobileLightVariant from 'util/getMobileLightVariant';
import Search from 'components/Search';

class ContentPageLayout extends PureComponent {
  static defaultProps = {
    hasMobileHeader: false,
  };

  static propTypes = {
    hasMobileHeader: PropTypes.bool,
    isSearchActive: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
  };

  render() {
    const { children, hasMobileHeader, isSearchActive, classes } = this.props;
    const mobileLightVariant = getMobileLightVariant();

    return (
      <div id={CONTENT_CONTAINER} className={classes.container}>
        {!mobileLightVariant && <Search show={!hasMobileHeader} />}
        <div
          className={classNames(classes.contentContainer, {
            [classes.contentContainerSearchActive]: isSearchActive,
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    height: 'auto',
    ...cssVariable.fullPageMinHeight,
    position: 'relative',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  contentContainer: {
    position: 'relative',
    minHeight: `calc(100vh - ${cssVariable.footerHeight})`,
  },
  contentContainerSearchActive: {
    ...cssVariable.fillAspectRatio,
    overflow: 'hidden',
  },
};

export default injectStyles(styles)(ContentPageLayout);
